import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BussinessRegAppService } from '../business-reg-app/bussiness-reg-app.service';

const dupEntryGrpRow = 0
const busGrpRow = 1
const FastTrackGrpRow = 5


@Injectable({
  providedIn: 'root'
})
export class Qlevel1Service implements Resolve<any>{
  
 

  constructor(private _busRegService: BussinessRegAppService) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    const TRCQGroups = JSON.parse(sessionStorage.getItem("TRCQGroups") ?? "[]")
    if(TRCQGroups.length !== 0){
      return  this._busRegService.getTRCCurrLevel(TRCQGroups[busGrpRow].questionGroupId,"1")
    }
    
  }
}

@Injectable({
  providedIn: 'root'
})
export class FastTracklevel1Service implements Resolve<any>{
  
 

  constructor(private _busRegService: BussinessRegAppService) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    const TRCQGroups = JSON.parse(sessionStorage.getItem("TRCQGroups") ?? "[]")
    if(TRCQGroups.length !== 0){
      return  this._busRegService.getGrpQuestions(TRCQGroups[FastTrackGrpRow].questionGroupId)
    }
    
  }
}



@Injectable({
  providedIn: 'root'
})



export class BusVerificationService implements Resolve<any>{

  constructor(private _busRegService: BussinessRegAppService) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    const TRCQGroups = JSON.parse(sessionStorage.getItem("TRCQGroups") ?? "[]")
    if(TRCQGroups.length !== 0){
      return this._busRegService.getGrpQuestions(TRCQGroups[dupEntryGrpRow].questionGroupId)
    }
  }


}

